const emitir_diario_de_classe = {
  path: "/emitir-diario-de-classe",
  redirect: "/emitir-diario-de-classe",
  meta: {
    breadCrumb: "Processo de Matrículas - Diário Classe da Turma",
  },
  children: [
    {
      path: "/emitir-diario-de-classe",
      name: "emitir_diario_de_classe",
      component: () =>
        import("@/views/EmitirDiarioDeClasse/EmitirDiarioDeClasseHome.vue"),
    },
  ],
};

export { emitir_diario_de_classe };
